export const siteSettings = {
  name: "Sky Vault Markets",
  link: "https://skyvaultmarket.live",
  email: "support@skyvaultmarket.live",
  appLink: "https://app.skyvaultmarket.live",
};
